import React from "react";

export const ExcelIcon = () => {
  return (
    <svg viewBox="0 0 32 32" height="18px" width="18px" fill="#000000">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <defs>
          <linearGradient
            id="a"
            x1="4.494"
            y1="-2092.086"
            x2="13.832"
            y2="-2075.914"
            gradientTransform="translate(0 2100)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#18884f"></stop>
            <stop offset="0.5" stopColor="#117e43"></stop>
            <stop offset="1" stopColor="#0b6631"></stop>
          </linearGradient>
        </defs>
        <title>file_type_excel</title>
        <path
          d="M19.581,15.35,8.512,13.4V27.809A1.192,1.192,0,0,0,9.705,29h19.1A1.192,1.192,0,0,0,30,27.809h0V22.5Z"
          style={{ fill: "#185c37" }}
        ></path>
        <path
          d="M19.581,3H9.705A1.192,1.192,0,0,0,8.512,4.191h0V9.5L19.581,16l5.861,1.95L30,16V9.5Z"
          style={{ fill: "#21a366" }}
        ></path>
        <path
          d="M8.512,9.5H19.581V16H8.512Z"
          style={{ fill: "#107c41" }}
        ></path>
        <path
          d="M16.434,8.2H8.512V24.45h7.922a1.2,1.2,0,0,0,1.194-1.191V9.391A1.2,1.2,0,0,0,16.434,8.2Z"
          style={{ opacity: 0.1, isolation: "isolate" }}
        ></path>
        <path
          d="M15.783,8.85H8.512V25.1h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
          style={{ opacity: 0.2, isolation: "isolate" }}
        ></path>
        <path
          d="M15.783,8.85H8.512V23.8h7.271a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.783,8.85Z"
          style={{ opacity: 0.2, isolation: "isolate" }}
        ></path>
        <path
          d="M15.132,8.85H8.512V23.8h6.62a1.2,1.2,0,0,0,1.194-1.191V10.041A1.2,1.2,0,0,0,15.132,8.85Z"
          style={{ opacity: 0.2, isolation: "isolate" }}
        ></path>
        <path
          d="M3.194,8.85H15.132a1.193,1.193,0,0,1,1.194,1.191V21.959a1.193,1.193,0,0,1-1.194,1.191H3.194A1.192,1.192,0,0,1,2,21.959V10.041A1.192,1.192,0,0,1,3.194,8.85Z"
          style={{ fill: "url(#a)" }}
        ></path>
        <path
          d="M5.7,19.873l2.511-3.884-2.3-3.862H7.758L9.013,14.6c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359,3.84,2.419,3.905H10.821l-1.45-2.711A2.355,2.355,0,0,1,9.2,16.8H9.176a1.688,1.688,0,0,1-.168.351L7.515,19.873Z"
          style={{ fill: "#fff" }}
        ></path>
        <path
          d="M28.806,3H19.581V9.5H30V4.191A1.192,1.192,0,0,0,28.806,3Z"
          style={{ fill: "#33c481" }}
        ></path>
        <path d="M19.581,16H30v6.5H19.581Z" style={{ fill: "#107c41" }}></path>
      </g>
    </svg>
  );
};

export const PhonePeIcon = () => (
  <svg
    viewBox="0 0 48 48"
    width={"20px"}
    height={"20px"}
    xmlns="http://www.w3.org/2000/svg"
    fill="#5F259F"
    stroke="#5F259F"
    strokeWidth="3.112" // Adjusted stroke-width for JSX
  >
    <defs>
      <style>{`.a{fill:none;stroke:#5F259F;stroke-linecap:round;stroke-linejoin:round;}`}</style>
    </defs>
    <circle className="a" cx="24" cy="24" r="21.5" />
    <line className="a" x1="19.8055" y1="8.5" x2="28.8973" y2="18.8312" />
    <line className="a" x1="13.2366" y1="18.8312" x2="34.7634" y2="18.8312" />
    <path
      className="a"
      d="M29.2874,39.5c-.4439-9.0064-.39-20.6688-.39-20.6688"
    />
    <path
      className="a"
      d="M18.97,18.8312c0,3.1275-.1189,7.93-.1189,9.0192a4.2326,4.2326,0,0,0,4.9636,4.2977,30.2014,30.2014,0,0,0,5.1918-1.1168"
    />
  </svg>
);

export const NetBanking = () => (
  <svg
    version="1.1"
    width={"60px"}
    height={"30px"}
    viewBox="0 0 511.999 511.999"
    xmlSpace="preserve"
    fill="brown"
    stroke="brown"
  >
    <g id="SVGRepo_browngCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g>
        <path
          style={{ fill: "brown" }}
          d="M133.336,435.199h245.328c13.993,0,25.336,11.342,25.336,25.332l0,0 c0,13.99-11.343,25.332-25.336,25.332H133.336c-13.993,0-25.336-11.342-25.336-25.332l0,0 C108,446.541,119.344,435.199,133.336,435.199z"
        ></path>
        <path
          style={{ fill: "brown" }}
          d="M32,26.135h448c17.673,0,32,14.327,32,32v256.001c0,17.673-14.327,32-32,32H32 c-17.673,0.001-32-14.326-32-32V58.135C0,40.462,14.327,26.135,32,26.135z"
        ></path>
      </g>
      <rect
        x="159.998"
        y="386.94"
        style={{ fill: "#CCCCCC" }}
        width="191.999"
        height="48.264"
      ></rect>
      <g>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M163.153,140.983c0,21.072-12.8,33.104-30.128,33.104c-17.72,0-28.904-13.52-28.904-32 c0-19.304,12.128-32.92,29.84-32.92C152.336,109.175,163.153,123.071,163.153,140.983z M116.248,141.911 c0,12.8,6.4,22.944,17.44,22.944s17.344-10.264,17.344-23.416c0-11.84-5.872-23.032-17.344-23.032S116.248,128.951,116.248,141.911 z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M173.073,173.055v-62.856h13.056l16.224,26.952c4.055,6.773,7.639,13.816,10.728,21.08h0.184 c-0.752-8.392-1.032-16.504-1.032-26.12v-21.912h10.632v62.856h-11.84l-16.416-27.609c-4.162-7.027-7.928-14.281-11.28-21.728 l-0.28,0.096c0.471,8.12,0.56,16.416,0.56,26.768v22.48L173.073,173.055z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M236.129,110.199H247.6v53.248h25.84v9.6h-37.312v-62.848H236.129z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M293.6,110.199v62.856h-11.472v-62.856H293.6z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M306.752,173.055v-62.856h13.056l16.192,26.952c4.055,6.773,7.639,13.816,10.728,21.08h0.184 c-0.752-8.392-1.032-16.504-1.032-26.12v-21.912h10.632v62.856h-11.84l-16.416-27.609c-4.161-7.027-7.928-14.281-11.28-21.728 l-0.28,0.096c0.471,8.12,0.552,16.416,0.552,26.768v22.48L306.752,173.055z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M404.969,145.175h-23.688v18.464h26.488v9.424h-37.96v-62.864h36.592v9.424h-25.12v16.224h23.688 V145.175z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M72.64,199.047c5.513-0.926,11.097-1.365,16.689-1.312c6.272-0.604,12.574,0.795,18,4 c4.151,2.439,6.65,6.939,6.528,11.752c-0.182,6.313-4.395,11.797-10.449,13.6v0.184c7.394,1.508,12.699,8.022,12.68,15.568 c0.084,5.026-2.153,9.81-6.064,12.968c-6.832,4.654-15.092,6.734-23.312,5.872c-4.706,0.02-9.41-0.261-14.08-0.84L72.64,199.047z M84.016,223.847h5.872c7.928,0,12.408-3.736,12.408-9.048c0-5.872-4.48-8.576-11.752-8.576c-2.187-0.071-4.374,0.085-6.528,0.464 V223.847z M84.016,252.759c2.015,0.208,4.039,0.299,6.064,0.272c7.368,0,13.896-2.8,13.896-10.536 c0-7.272-6.344-10.256-14.272-10.256H84L84.016,252.759z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M138.68,243.247l-5.408,17.816h-11.84l20.168-62.864h14.64l20.432,62.856h-12.344l-5.688-17.816 L138.68,243.247z M156.68,234.575l-4.944-15.488c-1.208-3.824-2.232-8.112-3.2-11.752h-0.176c-0.936,3.64-1.864,8-2.984,11.752 l-4.848,15.488H156.68z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M185.424,261.055v-62.856h13.056l16.224,26.952c4.055,6.773,7.639,13.816,10.728,21.08h0.168 c-0.752-8.392-1.032-16.504-1.032-26.12v-21.912h10.632v62.856h-11.84l-16.4-27.609c-4.161-7.022-7.927-14.27-11.28-21.712 l-0.28,0.096c0.471,8.12,0.552,16.416,0.552,26.768v22.48L185.424,261.055z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M248.48,198.199h11.376v28.912h0.28c1.496-2.4,3.08-4.664,4.568-6.816l16.416-22.104h14.168 l-21.6,26.768l23.032,36.096h-13.456l-17.816-28.8l-5.6,6.72v22.104H248.48L248.48,198.199L248.48,198.199z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M314.248,198.199v62.856h-11.464v-62.856H314.248z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M327.408,261.055v-62.856h13.056l16.224,26.952c4.053,6.773,7.639,13.816,10.728,21.08h0.184 c-0.752-8.392-1.032-16.504-1.032-26.12v-21.912h10.632v62.856h-11.84l-16.416-27.609c-4.161-7.027-7.928-14.281-11.28-21.728 l-0.28,0.096c0.471,8.12,0.552,16.416,0.552,26.768v22.48L327.408,261.055z"
        ></path>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M440.8,258.135c-6.504,2.294-13.344,3.491-20.24,3.544c-8.97,0.589-17.806-2.413-24.56-8.344 c-6.002-6.163-9.187-14.535-8.8-23.128c0-19.864,14.168-32.64,34.968-32.64c5.711-0.159,11.394,0.856,16.696,2.984l-2.512,9.224 c-4.506-1.923-9.375-2.845-14.272-2.704c-11.568-1.055-21.8,7.468-22.855,19.035c-0.107,1.172-0.115,2.351-0.025,3.525 c-1.099,11.435,7.28,21.595,18.715,22.694c1.034,0.099,2.073,0.121,3.109,0.065c2.949,0.15,5.898-0.293,8.672-1.304v-15.68h-11.065 v-9.04h22.168L440.8,258.135L440.8,258.135z"
        ></path>
      </g>
    </g>
  </svg>
);

export const DebitArrow = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="brown"
    stroke="brown"
    width="20px"
    height="20px"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="4"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g id="Complete">
        <g id="arrow-up-right">
          <g>
            <polyline
              data-name="Right"
              fill="none"
              id="Right-2"
              points="18.7 12.4 18.7 5.3 11.6 5.3"
              stroke="brown"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
            ></polyline>
            <line
              fill="none"
              stroke="brown"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="4"
              x1="5.3"
              x2="17.1"
              y1="18.7"
              y2="6.9"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CreditArrow = () => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="green"
    stroke="green"
    width="25px"
    height="25px"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="10"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <g id="Complete">
        <g id="arrow-down-left">
          <g>
            <polyline
              data-name="Right"
              fill="none"
              id="Right-2"
              points="5.3 11.6 5.3 18.7 12.4 18.7"
              stroke="green"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
            ></polyline>
            <line
              fill="none"
              stroke="green"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              x1="18.7"
              x2="6.9"
              y1="5.3"
              y2="17.1"
            ></line>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const CustomArrowDownIcon = () => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    width={"20px"}
    height={"20px"}
    xmlns="http://www.w3.org/2000/svg"
    stroke="green"
    strokeWidth="0.00001" // Adjusted stroke width to be thinner
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracer" strokeLinecap="round" strokeLinejoin="round">
      <path
        d="M9.16421 9.66421L15.4142 3.41421L12.5858 0.585785L6.33579 6.83578L3.5 4L2 5.5V14H10.5L12 12.5L9.16421 9.66421Z"
        fill="green"
      />
    </g>
  </svg>
);

export const CustomIconInternetBankingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="24"
    height="24"
  >
    <path
      d="M12 12h3m-3 6h3m-3-6V6m0 8v6m3-7v-4M11 2.29c.49-.18.993.088 1.172.5l1.828 5c.18.41.02.875-.366 1.1l-.939.4M11 21c-6.627 0-12-5.373-12-12H0c0 6.627 5.373 12 12 12zm12-12c0-6.627-5.373-12-12-12v2c5.523 0 10 4.477 10 10h2z"
      fill="#000000"
    />
  </svg>
);

export const InternetBankingIcon = () => {
  return (
    <svg
      viewBox="0 0 48 48"
      width="30"
      height="30"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="layer1" transform="translate(-314.00003,-449)">
        <path
          d="m 319,463.48769 19,-10 19,10 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <path
          d="M 331.48047,456.91933 319,463.48769 h 27.64648 a 21.191124,12.336339 0 0 0 -15.16601,-6.56836 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
            strokeOpacity: 1,
          }}
        ></path>
        <path
          d="m 319,463.48769 h 38 v 4 h -38 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <path
          d="m 319,463.48769 v 4 h 29.76172 a 21.191124,12.336339 0 0 0 -2.11524,-4 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
            strokeOpacity: 1,
          }}
        ></path>
        <path
          d="m 320,467.48769 h 8 l -2,3 v 12.98819 l 2,3.01181 h -8 l 2,-3.01401 v -12.98599 z"
          style={{
            fill: "orange",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <path
          d="m 348.00009,467.48769 h 8 l -2,3 v 12.98819 l 2,3.01181 h -8 l 2,-3.01401 v -12.98599 z"
          style={{
            fill: "orange",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <path
          d="m 333.99991,467.48769 h 8 l -2,3 v 12.98819 l 2,3.01181 h -8 l 2,-3.01401 v -12.98599 z"
          style={{
            fill: "orange",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <ellipse
          cx="338"
          cy="459.4877"
          rx="0.93075401"
          ry="0.92241609"
          style={{
            fill: "#0071bd",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></ellipse>
        <ellipse
          cx="341.38382"
          cy="459.4877"
          rx="0.93075401"
          ry="0.92241609"
          style={{
            fill: "#0071bd",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></ellipse>
        <ellipse
          cx="334.58218"
          cy="459.4877"
          rx="0.93075401"
          ry="0.92241609"
          style={{
            fill: "#0071bd",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></ellipse>
        <path
          d="m 319,486.48769 h 38 v 6 h -38 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            stroke: "none",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
        <path
          d="m 319,486.48769 v 3.16992 h 30.70312 a 3.68215,3.68215 0 0 0 3.60157,-3.16992 z"
          style={{
            fill: "#e7e7e7",
            fillOpacity: 1,
            fillRule: "evenodd",
            strokeWidth: 2,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeMiterlimit: 4.1,
          }}
        ></path>
      </g>
    </svg>
  );
};

export const HandCashIcon = () => {
  return (
    <svg
      width="40" // Set the width to 40px
      height="60" // Set the height to 60px
      viewBox="0 0 64 64" // Keep the original viewbox to maintain aspect ratio
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="3" // Corrected to camelCase
      stroke="#FFA500"
      fill="none"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect x="7.18" y="16.7" width="50.86" height="29.87"></rect>
        <path d="M17.22,16.55a10,10,0,0,1-10,10.05"></path>
        <path d="M17.51,46.57a10.05,10.05,0,0,0-10-10"></path>
        <path d="M48.16,16.55A10.05,10.05,0,0,0,58.21,26.6"></path>
        <path d="M48,46.57a10.05,10.05,0,0,1,10-10"></path>
        <path
          d="M28.47,22.3H31c2.49,0,5.23.81,5.23,4.6,0,4.11-3.48,5.68-7.18,5.26a.21.21,0,0,0-.17.36L36.74,41"
          strokeLinecap="round"
        ></path>
        <line
          x1="39.24"
          y1="22.3"
          x2="30.45"
          y2="22.3"
          strokeLinecap="round"
        ></line>
        <line
          x1="28.59"
          y1="27.03"
          x2="39.3"
          y2="27.03"
          strokeLinecap="round"
        ></line>
      </g>
    </svg>
  );
};

export const WhiteSVGIcon = () => (
  <svg
    fill="#ffffff" // Set fill color to white
    width="25" // Set width to 25
    height="25" // Set height to 25
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M17.0020048,13 C17.5542895,13 18.0020048,13.4477153 18.0020048,14 C18.0020048,14.5128358 17.6159646,14.9355072 17.1186259,14.9932723 L17.0020048,15 L5.41700475,15 L8.70911154,18.2928932 C9.0695955,18.6533772 9.09732503,19.2206082 8.79230014,19.6128994 L8.70911154,19.7071068 C8.34862757,20.0675907 7.78139652,20.0953203 7.38910531,19.7902954 L7.29489797,19.7071068 L2.29489797,14.7071068 C1.69232289,14.1045317 2.07433707,13.0928192 2.88837381,13.0059833 L3.00200475,13 L17.0020048,13 Z M16.6128994,4.20970461 L16.7071068,4.29289322 L21.7071068,9.29289322 C22.3096819,9.8954683 21.9276677,10.9071808 21.1136309,10.9940167 L21,11 L7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.48716416 6.38604019,9.06449284 6.88337887,9.00672773 L7,9 L18.585,9 L15.2928932,5.70710678 C14.9324093,5.34662282 14.9046797,4.77939176 15.2097046,4.38710056 L15.2928932,4.29289322 C15.6533772,3.93240926 16.2206082,3.90467972 16.6128994,4.20970461 Z" />
    </g>
  </svg>
);

export const CustomIconCreditCardIcon = () => {
  return (
    <svg
      width="60" // Set the width to 70px
      height="40" // Set the height to 40px
      viewBox="0 -11 70 70" // Keep the original viewbox dimensions for scaling
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect
          x="0.5"
          y="0.5"
          width="69"
          height="47"
          rx="5.5"
          fill="white"
          stroke="#898789"
        ></rect>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.3945 34.7619C33.0114 36.8184 29.92 38.0599 26.5421 38.0599C19.0047 38.0599 12.8945 31.8788 12.8945 24.254C12.8945 16.6291 19.0047 10.448 26.5421 10.448C29.92 10.448 33.0114 11.6895 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z"
          fill="#ED0006"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.3945 34.7619C38.3289 32.2296 40.1896 28.4616 40.1896 24.254C40.1896 20.0463 38.3289 16.2783 35.3945 13.7461C37.7777 11.6895 40.869 10.448 44.247 10.448C51.7843 10.448 57.8945 16.6291 57.8945 24.254C57.8945 31.8788 51.7843 38.0599 44.247 38.0599C40.869 38.0599 37.7777 36.8184 35.3945 34.7619Z"
          fill="#F9A000"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.3946 13.7461C38.329 16.2784 40.1897 20.0463 40.1897 24.254C40.1897 28.4616 38.329 32.2295 35.3946 34.7618C32.4603 32.2295 30.5996 28.4616 30.5996 24.254C30.5996 20.0463 32.4603 16.2784 35.3946 13.7461Z"
          fill="#FF5E00"
        ></path>
      </g>
    </svg>
  );
};

export const CustomIconVisaIcon = () => {
  return (
    <svg
      width="60" // Set the width to 60px
      height="40" // Set the height to 40px
      viewBox="0 -11 70 70" // The original viewBox to maintain the aspect ratio
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect
          x="0.5"
          y="0.5"
          width="69"
          height="47"
          rx="5.5"
          fill="white"
          stroke="#D9D9D9"
        ></rect>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.2505 32.5165H17.0099L13.8299 20.3847C13.679 19.8267 13.3585 19.3333 12.8871 19.1008C11.7106 18.5165 10.4142 18.0514 9 17.8169V17.3498H15.8313C16.7742 17.3498 17.4813 18.0514 17.5991 18.8663L19.2491 27.6173L23.4877 17.3498H27.6104L21.2505 32.5165ZM29.9675 32.5165H25.9626L29.2604 17.3498H33.2653L29.9675 32.5165ZM38.4467 21.5514C38.5646 20.7346 39.2717 20.2675 40.0967 20.2675C41.3931 20.1502 42.8052 20.3848 43.9838 20.9671L44.6909 17.7016C43.5123 17.2345 42.216 17 41.0395 17C37.1524 17 34.3239 19.1008 34.3239 22.0165C34.3239 24.2346 36.3274 25.3992 37.7417 26.1008C39.2717 26.8004 39.861 27.2675 39.7431 27.9671C39.7431 29.0165 38.5646 29.4836 37.3881 29.4836C35.9739 29.4836 34.5596 29.1338 33.2653 28.5494L32.5582 31.8169C33.9724 32.3992 35.5025 32.6338 36.9167 32.6338C41.2752 32.749 43.9838 30.6502 43.9838 27.5C43.9838 23.5329 38.4467 23.3004 38.4467 21.5514ZM58 32.5165L54.82 17.3498H51.4044C50.6972 17.3498 49.9901 17.8169 49.7544 18.5165L43.8659 32.5165H47.9887L48.8116 30.3004H53.8772L54.3486 32.5165H58ZM51.9936 21.4342L53.1701 27.1502H49.8723L51.9936 21.4342Z"
          fill="#172B85"
        ></path>
      </g>
    </svg>
  );
};
export const GooglePayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    id="google-pay"
    width={"60px"}
    height={"50px"}
  >
    <path
      fill="#5F6368"
      d="M10.917 11.496V14.4h-.922V7.227h2.444a2.206 2.206 0 0 1 1.583.621c.429.386.67.938.661 1.514a1.985 1.985 0 0 1-.661 1.523c-.428.408-.956.612-1.583.611h-1.522zm0-3.386v2.505h1.545c.343.01.673-.124.912-.371.484-.47.496-1.245.024-1.729l-.024-.024a1.204 1.204 0 0 0-.912-.381h-1.545zm5.89 1.222c.682 0 1.219.182 1.613.546.394.364.591.864.591 1.497v3.026h-.881v-.682h-.04c-.382.561-.89.842-1.523.842-.541 0-.993-.16-1.357-.481a1.538 1.538 0 0 1-.546-1.202c0-.508.192-.912.576-1.212.384-.3.896-.451 1.538-.451.547 0 .998.1 1.352.3v-.211a1.046 1.046 0 0 0-.381-.815 1.304 1.304 0 0 0-.89-.336c-.514 0-.922.217-1.222.651l-.811-.511c.445-.641 1.106-.961 1.981-.961zm-1.193 3.566a.739.739 0 0 0 .305.601c.204.16.457.246.716.24a1.472 1.472 0 0 0 1.037-.431c.305-.288.458-.624.458-1.012-.288-.229-.688-.344-1.202-.344-.374 0-.687.09-.937.271-.251.185-.377.408-.377.675zm8.457-3.406-3.077 7.073h-.951l1.142-2.475-2.025-4.598h1.002l1.463 3.526h.02l1.423-3.526h1.003z"
    />
    <path
      fill="#4285F4"
      d="M8.079 11.7c0-.281-.023-.561-.071-.838H4.121v1.587h2.226a1.905 1.905 0 0 1-.823 1.252v1.031h1.329c.778-.716 1.226-1.777 1.226-3.032z"
    />
    <path
      fill="#34A853"
      d="M4.121 15.728c1.112 0 2.049-.365 2.732-.995l-1.329-1.031c-.37.251-.846.394-1.403.394-1.075 0-1.987-.725-2.314-1.701H.439v1.062a4.12 4.12 0 0 0 3.682 2.271z"
    />
    <path
      fill="#FBBC04"
      d="M1.808 12.395a2.464 2.464 0 0 1 0-1.578V9.756H.439a4.124 4.124 0 0 0 0 3.702l1.369-1.063z"
    />
    <path
      fill="#EA4335"
      d="M4.121 9.117a2.24 2.24 0 0 1 1.581.618l1.177-1.176a3.968 3.968 0 0 0-2.758-1.074A4.12 4.12 0 0 0 .439 9.756l1.369 1.062c.326-.977 1.238-1.701 2.313-1.701z"
    />
  </svg>
);
export const GreenDeleteIcon = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" width="18px" height="18px">
      <path
        opacity="0.5"
        d="M22 16.0003V15.0003C22 12.1718 21.9998 10.7581 21.1211 9.8794C20.2424 9.00072 18.8282 9.00072 15.9998 9.00072H7.99977C5.17135 9.00072 3.75713 9.00072 2.87845 9.8794C2 10.7579 2 12.1711 2 14.9981V15.0003V16.0003C2 18.8287 2 20.2429 2.87868 21.1216C3.75736 22.0003 5.17157 22.0003 8 22.0003H16H16C18.8284 22.0003 20.2426 22.0003 21.1213 21.1216C22 20.2429 22 18.8287 22 16.0003Z"
        fill="#097969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1.25C11.5858 1.25 11.25 1.58579 11.25 2L11.25 12.9726L9.56943 11.0119C9.29986 10.6974 8.82639 10.661 8.51189 10.9306C8.1974 11.2001 8.16098 11.6736 8.43054 11.9881L11.4305 15.4881C11.573 15.6543 11.781 15.75 12 15.75C12.2189 15.75 12.4269 15.6543 12.5694 15.4881L15.5694 11.9881C15.839 11.6736 15.8026 11.2001 15.4881 10.9306C15.1736 10.661 14.7001 10.6974 14.4305 11.0119L12.75 12.9726L12.75 2C12.75 1.58579 12.4142 1.25 12 1.25Z"
        fill="#097969"
      />
    </svg>
  );
};

export const PhonePeIconNew = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={"80px"}
    height={"50px"}
    viewBox="0 0 1366 768"
    id="phonepe"
  >
    <defs>
      <clipPath id="a">
        <rect width="1366" height="768" fill="none"></rect>
      </clipPath>
    </defs>
    <g clipPath="url(#a)">
      <path
        fill="#5f259f"
        d="M332.63 514.18c-3.88-.38-7.78-.64-11.64-1.15-25.26-3.35-47.76-13.07-67.18-29.6a127.87 127.87 0 0 1-41.44-65.75 124.29 124.29 0 0 1-3.78-42.55c2-24.95 10.33-47.61 25.5-67.51 21.24-27.87 49.33-44.9 84-50.05 37.84-5.63 72 3.92 101.51 28.13 25.43 20.83 40.77 47.94 45.43 80.46 5.5 38.35-4.36 72.79-29.38 102.44-21.07 25-48.24 39.43-80.53 44.3-4.05.62-8.16.86-12.24 1.28zm-23.78-171c-10.43 0-20.85 0-31.28 0-2.78 0-3.77.84-4 3.58a35.11 35.11 0 0 0 .15 8 9.19 9.19 0 0 0 9.18 8.06c2.4.05 4.8 0 7.2 0 3 0 3 0 3 2.95q0 16.75 0 33.5a50.67 50.67 0 0 0 1.73 13.2c3.21 12 10.21 20.59 22.36 24.17 10.15 3 20.34 2.27 30.36-1 2.35-.77 2.39-.77 2.4 1.72 0 6.92-.05 13.84 0 20.76a11.07 11.07 0 0 0 11.25 11.22c3.29 0 6.59.06 9.88 0a4.2 4.2 0 0 0 4.29-4.3c0-.82 0-1.64 0-2.46q0-48.42 0-96.81c0-3.68 0-3.68 3.58-3.68 4.18 0 8.37 0 12.55 0 3.1 0 4-.95 4-4.1q0-3.07 0-6.17c-.07-5.6-3.83-9.33-9.48-9.38q-7.41-.06-14.81 0a4 4 0 0 1-3.41-1.51c-1.85-2.2-3.77-4.35-5.66-6.51Q346 315.77 329.79 297.18a13.29 13.29 0 0 0-10.6-5c-6.67.08-12.59 3-18.74 5.07-1.87.62-2.07 3-.76 4.5a20 20 0 0 0 1.46 1.45Q321.07 322.11 341 341c.48.45 1.36.88 1.14 1.57-.28.9-1.29.53-2 .53-10.43 0-20.85 0-31.28 0M1158.42 427c-1.38 2.26-3.36 3.07-6.05 3.05-13.65-.1-27.3 0-40.95-.09-2 0-2.9.46-2.82 2.59.07 1.56-.34 3.13-.36 4.7-.11 7.55 4.75 12.61 12.33 13.16s14.78-1.54 21.66-4.74c4.91-2.27 5.88-2 8.89 2.6 2.14 3.26 4 6.58 2.52 10.73a10 10 0 0 1-4.77 5.69c-10.45 5.53-21.64 7.14-33.3 6.12a42.24 42.24 0 0 1-15.77-4.33c-11.57-6-17.36-15.76-17.91-28.45-.46-10.6-.24-21.24-.06-31.86.29-18.13 12.62-31.35 31-33.51a57.6 57.6 0 0 1 19.64.67c14.66 3.35 23.45 12.93 25.57 27.82.08.53.23 1.06.35 1.59zm-36.92-12.42c3.84 0 7.68 0 11.52 0 1.39 0 2-.5 2-1.92 0-2.19 0-4.38 0-6.57-.25-7-4.21-11.67-11.19-12.56-8.84-1.13-15.34 3.42-15.52 12.79 0 2 .07 4 0 6s.67 2.36 2.42 2.31c3.63-.09 7.26 0 10.9 0M550.94 450.08c0 4.8 0 9.59 0 14.39 0 3.27-1.71 5.18-5 5.26q-7.71.18-15.42 0c-3-.07-4.64-1.74-5-4.68a18.35 18.35 0 0 1-.13-2.46q0-54.66 0-109.32c0-1 .09-1.92.18-2.87a6.32 6.32 0 0 1 4.67-5.67c11.27-3.75 22.81-6 34.72-5.69 9.35.27 18.19 2.5 26 7.88 9 6.17 14.39 14.76 15.69 25.46a114.65 114.65 0 0 1-.17 32.15 37.2 37.2 0 0 1-32.62 30.79c-7.15.87-14.24.86-21.12-1.65-1.53-.56-1.77.13-1.77 1.42 0 5 0 10 0 15m.79-63.37c0 7.12.06 14.23 0 21.35a3.19 3.19 0 0 0 2.24 3.38c3.77 1.71 7.71 1.75 11.7 1.53 9.35-.51 16-7.36 16-16.72-.05-6.94.53-13.88-.75-20.82-1-5.57-3.43-9.93-8.67-12.37-6.18-2.88-12.49-2.51-18.84-.59-1.44.44-1.61 1.4-1.61 2.68 0 7.18 0 14.37 0 21.56M990.88 407.68V353.2c0-5.69 1.28-7.39 6.65-9.08 10.54-3.31 21.29-5.35 32.36-5.1 10.67.24 20.62 2.91 29.1 9.78a35.37 35.37 0 0 1 13.21 23.86 114.3 114.3 0 0 1 0 30.75c-2.49 16.62-13.65 27.94-30.3 31.43a43 43 0 0 1-23.15-1c-1.82-.64-2.24-.15-2.23 1.65.06 9.39 0 18.78 0 28.16 0 4.41-1.69 6.15-6 6.17s-8.78 0-13.17 0-6.35-1.86-6.4-6.38V407.68zm26.42-21c0 7.19.05 14.39 0 21.58a3 3 0 0 0 2 3.12c3.75 1.77 7.69 1.84 11.69 1.64 9.49-.45 16.12-7.31 16.21-16.78 0-4.59 0-9.19 0-13.78a39.82 39.82 0 0 0-1.77-10.63 13.1 13.1 0 0 0-7.08-8.4c-6.09-3.1-12.41-2.85-18.83-1.17a2.64 2.64 0 0 0-2.27 3c.1 7.13 0 14.25 0 21.38M620.67 404q0-29.81 0-59.62c0-4.51 1.64-6.19 6.21-6.16 3.29 0 6.59-.28 9.86.27a10.91 10.91 0 0 1 9.27 9.65c.67 6.63.14 13.29.27 19.93 0 1.78.06 3.56 0 5.34-.06 1.51.33 2.15 2 1.68a69.5 69.5 0 0 1 13.78-2.15c17.51-1.32 31.54 8.93 35.3 26a54.47 54.47 0 0 1 1.36 12c0 17.62 0 35.23 0 52.84 0 4.13-1.74 5.92-5.83 6q-3.92.06-7.82 0a11.92 11.92 0 0 1-12-12.08q-.06-22.41 0-44.81a29.29 29.29 0 0 0-1-8.75c-1.49-4.84-4.8-7.51-9.75-8.26a36.52 36.52 0 0 0-13.65.92c-1.9.43-2.49 1.37-2.48 3.29q.09 30.84 0 61.67c0 .82 0 1.65 0 2.47-.27 3.74-2 5.49-5.76 5.54q-7.1.09-14.2 0c-3.87 0-5.62-1.86-5.62-5.73q0-30 0-60M712.11 420.9c.23-4.79-.42-11 .33-17.11 1.81-14.86 10-24.47 24.27-28.7a53.23 53.23 0 0 1 35.12 1.13c13.13 5.1 20 15.06 21.11 29 .81 10.25.38 20.54.27 30.81s-3.26 19.68-11.48 26.68c-6.17 5.26-13.53 7.69-21.41 8.7a54.73 54.73 0 0 1-25.17-2.34c-14.06-4.85-22.83-16.93-23-31.78-.07-5 0-10 0-16.37m26.94.25c0 5.54-.07 10 0 14.44.15 7.85 3.83 12.37 11.43 13.33 9 1.15 16.81-2 17.09-12.94.23-9.1.16-18.21 0-27.32-.13-7.43-4-12.17-10.56-13.47a24.66 24.66 0 0 0-5.95-.19c-6.47.31-10.85 4.42-11.7 10.82-.71 5.46-.11 10.95-.34 15.33M949.33 430c-7.07 0-14.13.06-21.2 0-1.78 0-2.52.66-2.58 2.33-.07 2.32-.7 4.61-.38 7 .86 6.36 5.53 10.62 12.08 11.14 7.62.6 14.68-1.28 21.47-4.52 5.36-2.56 6.43-2.26 9.62 2.82 2.13 3.38 3.9 6.85 2 11a8.66 8.66 0 0 1-3.72 4.52c-16.52 8.35-33.49 10-50.45 1.88-10.56-5-16.23-14.28-17.12-25.86a263.21 263.21 0 0 1 0-37.15c.89-13.92 10.1-24.95 24-28.92a51.91 51.91 0 0 1 29.23-.07c13 3.79 20.43 12.79 22.58 26 1.32 8.22.85 16.54.7 24.82-.07 3.51-2 5.05-5.63 5.06H949.33m-10.8-15.42c3.9 0 7.81 0 11.71 0 1.28 0 1.9-.42 1.86-1.78-.06-2.12.06-4.25-.05-6.36-.37-7.28-4.38-12-11.37-12.9-7.22-.95-14.13 1.85-15.39 10.94-.38 2.73-.1 5.47-.22 8.2-.07 1.44.56 1.92 1.95 1.9 3.84-.05 7.67 0 11.51 0M808 424.22q0-19.22 0-38.44c0-4.34 1.42-6.12 5.53-7.49a99.42 99.42 0 0 1 31.89-5.45c10.53 0 20.65 1.84 29 9 6.7 5.75 9.8 13.34 11.14 21.84a53.77 53.77 0 0 1 .45 8.4q0 25.8 0 51.6c0 4.41-1.64 6.09-6.1 6.06-3.35 0-6.72.3-10.06-.24-5.57-.91-9.18-5-9.2-10.64-.06-14.6 0-29.19 0-43.79a48.87 48.87 0 0 0-.75-9.81c-1.32-6.41-5.54-10-12.06-10.29a61 61 0 0 0-11.68.69c-2 .31-2.55 1.19-2.54 3.11q.07 31.44 0 62.9c0 .82 0 1.65 0 2.46a5 5 0 0 1-5 4.81c-5.28.1-10.57.11-15.85 0-3-.06-4.77-2.09-4.78-5.27q0-19.74 0-39.47"
      ></path>
      <path
        fill="#5f259f"
        d="M350,388.34c0,7.61-.05,15.21,0,22.81a3,3,0,0,1-2.31,3.3,36.61,36.61,0,0,1-15.21,1.84c-8.75-.83-13.64-6-14.38-14.87-.68-8.14-.18-16.29-.32-24.44-.06-4,0-7.94,0-11.91,0-1.65.54-2.32,2.27-2.31,9.19.06,18.38.08,27.56,0,2,0,2.42.81,2.41,2.58-.06,7.67,0,15.34,0,23"
      ></path>
    </g>
  </svg>
);

export const PdfIcon = () => (
  <svg
    height="24px"
    width="24px"
    version="1.1"
    id="Layer_1"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        style={{ fill: "#E2E5E7" }}
        d="M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z"
      />
      <path
        style={{ fill: "#B0B7BD" }}
        d="M384,128h96L352,0v96C352,113.6,366.4,128,384,128z"
      />
      <polygon style={{ fill: "#CAD1D8" }} points="480,224 384,128 480,128 " />
      <path
        style={{ fill: "#F15642" }}
        d="M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16 V416z"
      />
      <g>
        <path
          style={{ fill: "#FFFFFF" }}
          d="M101.744,303.152c0-4.224,3.328-8.832,8.688-8.832h29.552c16.64,0,31.616,11.136,31.616,32.48 c0,20.224-14.976,31.488-31.616,31.488h-21.36v16.896c0,5.632-3.584,8.816-8.192,8.816c-4.224,0-8.688-3.184-8.688-8.816V303.152z M118.624,310.432v31.872h21.36c8.576,0,15.36-7.568,15.36-15.504c0-8.944-6.784-16.368-15.36-16.368H118.624z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M196.656,384c-4.224,0-8.832-2.304-8.832-7.92v-72.672c0-4.592,4.608-7.936,8.832-7.936h29.296 c58.464,0,57.184,88.528,1.152,88.528H196.656z M204.72,311.088V368.4h21.232c34.544,0,36.08-57.312,0-57.312H204.72z"
        />
        <path
          style={{ fill: "#FFFFFF" }}
          d="M303.872,312.112v20.336h32.624c4.608,0,9.216,4.608,9.216,9.072c0,4.224-4.608,7.68-9.216,7.68 h-32.624v26.864c0,4.48-3.184,7.92-7.664,7.92c-5.632,0-9.072-3.44-9.072-7.92v-72.672c0-4.592,3.456-7.936,9.072-7.936h44.912 c5.632,0,8.96,3.344,8.96,7.936c0,4.096-3.328,8.704-8.96,8.704h-37.248V312.112z"
        />
      </g>
      <path
        style={{ fill: "#CAD1D8" }}
        d="M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z"
      />
    </g>
  </svg>
);

// ... existing code ...
export const CurrencyIcon = () => (
  <svg
    height="30px"
    width="30px"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    fill="#000000"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <circle style={{ fill: "#324A5E" }} cx="256" cy="256" r="256"></circle>
      <path
        style={{ fill: "#2B3B4E" }}
        d="M510.376,284.815L365.011,139.45l-108.285,21.583l-115.884,4.486l35.323,35.323l-37.376,19.373 l55.236,55.236l-12.438,12.441l93.077,125.285l79.367,79.367C438.294,457.581,499.834,378.914,510.376,284.815z"
      ></path>
      <path
        style={{ fill: "#FFD15D" }}
        d="M352.108,190.923h-41.041c-1.838-7.38-4.73-14.348-8.576-20.687h49.617 c9.997,0,18.101-8.104,18.101-18.101s-8.104-18.101-18.101-18.101H152.997c-9.997,0-18.101,8.104-18.101,18.101 s8.104,18.101,18.101,18.101h85.333c14.853,0,27.776,8.395,34.29,20.687H152.997c-9.997,0-18.101,8.104-18.101,18.101 c0,9.997,8.104,18.101,18.101,18.101H272.62c-6.515,12.291-19.437,20.687-34.29,20.687h-85.333c-7.321,0-13.921,4.411-16.724,11.173 c-2.801,6.765-1.253,14.55,3.924,19.727l142.222,142.222c3.536,3.534,8.166,5.301,12.8,5.301c4.632,0,9.264-1.767,12.8-5.301 c7.07-7.07,7.07-18.53,0-25.6L196.698,284.013h41.632c35.109,0,64.648-24.257,72.768-56.889h41.01 c9.997,0,18.101-8.104,18.101-18.101C370.209,199.027,362.105,190.923,352.108,190.923z"
      ></path>
      <g>
        <path
          style={{ fill: "#F9B54C" }}
          d="M282.419,420.935c3.536,3.534,8.166,5.301,12.8,5.301c4.632,0,9.264-1.767,12.8-5.301 c7.07-7.07,7.07-18.53,0-25.6l-69.832-69.832v51.198L282.419,420.935z"
        ></path>
        <path
          style={{ fill: "#F9B54C" }}
          d="M352.108,190.923h-41.041c-1.838-7.38-4.73-14.348-8.576-20.687h49.617 c9.997,0,18.101-8.104,18.101-18.101s-8.104-18.101-18.101-18.101H238.187v36.202h0.143c14.853,0,27.776,8.395,34.29,20.687 h-34.433v36.202h34.433c-6.515,12.291-19.437,20.687-34.29,20.687h-0.143v36.202h0.143c35.109,0,64.648-24.257,72.768-56.889h41.01 c9.997,0,18.101-8.104,18.101-18.101C370.209,199.027,362.105,190.923,352.108,190.923z"
        ></path>
      </g>
    </g>
  </svg>
);
export const DeleteIcon = () => {
  return (
    <svg
      width={"25px"}
      height={"25px"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M2.75 6.16667C2.75 5.70644 3.09538 5.33335 3.52143 5.33335L6.18567 5.3329C6.71502 5.31841 7.18202 4.95482 7.36214 4.41691C7.36688 4.40277 7.37232 4.38532 7.39185 4.32203L7.50665 3.94993C7.5769 3.72179 7.6381 3.52303 7.72375 3.34536C8.06209 2.64349 8.68808 2.1561 9.41147 2.03132C9.59457 1.99973 9.78848 1.99987 10.0111 2.00002H13.4891C13.7117 1.99987 13.9056 1.99973 14.0887 2.03132C14.8121 2.1561 15.4381 2.64349 15.7764 3.34536C15.8621 3.52303 15.9233 3.72179 15.9935 3.94993L16.1083 4.32203C16.1279 4.38532 16.1333 4.40277 16.138 4.41691C16.3182 4.95482 16.8778 5.31886 17.4071 5.33335H19.9786C20.4046 5.33335 20.75 5.70644 20.75 6.16667C20.75 6.62691 20.4046 7 19.9786 7H3.52143C3.09538 7 2.75 6.62691 2.75 6.16667Z"
          fill="#0071bd"
        />
        <path
          opacity="0.5"
          d="M11.6068 21.9998H12.3937C15.1012 21.9998 16.4549 21.9998 17.3351 21.1366C18.2153 20.2734 18.3054 18.8575 18.4855 16.0256L18.745 11.945C18.8427 10.4085 18.8916 9.6402 18.45 9.15335C18.0084 8.6665 17.2628 8.6665 15.7714 8.6665H8.22905C6.73771 8.6665 5.99204 8.6665 5.55047 9.15335C5.10891 9.6402 5.15777 10.4085 5.25549 11.945L5.515 16.0256C5.6951 18.8575 5.78515 20.2734 6.66534 21.1366C7.54553 21.9998 8.89927 21.9998 11.6068 21.9998Z"
          fill="#0071bd"
        />
      </g>
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      height={"25px"}
      width={"25px"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          opacity="0.4"
          d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
          stroke="#0071bd"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          d="M16.0399 3.01976L8.15988 10.8998C7.85988 11.1998 7.55988 11.7898 7.49988 12.2198L7.06988 15.2298C6.90988 16.3198 7.67988 17.0798 8.76988 16.9298L11.7799 16.4998C12.1999 16.4398 12.7899 16.1398 13.0999 15.8398L20.9799 7.95976C22.3399 6.59976 22.9799 5.01976 20.9799 3.01976C18.9799 1.01976 17.3999 1.65976 16.0399 3.01976Z"
          stroke="#0071bd"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
        <path
          opacity="0.4"
          d="M14.9102 4.1499C15.5802 6.5399 17.4502 8.4099 19.8502 9.0899"
          stroke="#0071bd"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  );
};

export const CallIcon = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none" height={"25px"} width={"25px"}>
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3545 22.2323C15.3344 21.7262 11.1989 20.2993 7.44976 16.5502C3.70065 12.8011 2.2738 8.66559 1.76767 6.6455C1.47681 5.48459 2.00058 4.36434 2.88869 3.72997L5.21694 2.06693C6.57922 1.09388 8.47432 1.42407 9.42724 2.80051L10.893 4.91776C11.5152 5.8165 11.3006 7.0483 10.4111 7.68365L9.24234 8.51849C9.41923 9.1951 9.96939 10.5846 11.6924 12.3076C13.4154 14.0306 14.8049 14.5807 15.4815 14.7576L16.3163 13.5888C16.9517 12.6994 18.1835 12.4847 19.0822 13.1069L21.1995 14.5727C22.5759 15.5257 22.9061 17.4207 21.933 18.783L20.27 21.1113C19.6356 21.9994 18.5154 22.5232 17.3545 22.2323ZM8.86397 15.136C12.2734 18.5454 16.0358 19.8401 17.8405 20.2923C18.1043 20.3583 18.4232 20.2558 18.6425 19.9488L20.3056 17.6205C20.6299 17.1665 20.5199 16.5348 20.061 16.2171L17.9438 14.7513L17.0479 16.0056C16.6818 16.5182 16.0047 16.9202 15.2163 16.7501C14.2323 16.5378 12.4133 15.8569 10.2782 13.7218C8.1431 11.5867 7.46219 9.7677 7.24987 8.7837C7.07977 7.9953 7.48181 7.31821 7.99439 6.95208L9.24864 6.05618L7.78285 3.93893C7.46521 3.48011 6.83351 3.37005 6.37942 3.6944L4.05117 5.35744C3.74413 5.57675 3.64162 5.89565 3.70771 6.15943C4.15989 7.96418 5.45459 11.7266 8.86397 15.136Z"
          fill="#0071bd"
        ></path>{" "}
      </g>
    </svg>
  );
};

export const AddIcon = () => {
  return (
    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" stroke="">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <rect width="24" height="24" fill="white"></rect>{" "}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9ZM7.25007 2.38782C8.54878 2.0992 10.1243 2 12 2C13.8757 2 15.4512 2.0992 16.7499 2.38782C18.06 2.67897 19.1488 3.176 19.9864 4.01358C20.824 4.85116 21.321 5.94002 21.6122 7.25007C21.9008 8.54878 22 10.1243 22 12C22 13.8757 21.9008 15.4512 21.6122 16.7499C21.321 18.06 20.824 19.1488 19.9864 19.9864C19.1488 20.824 18.06 21.321 16.7499 21.6122C15.4512 21.9008 13.8757 22 12 22C10.1243 22 8.54878 21.9008 7.25007 21.6122C5.94002 21.321 4.85116 20.824 4.01358 19.9864C3.176 19.1488 2.67897 18.06 2.38782 16.7499C2.0992 15.4512 2 13.8757 2 12C2 10.1243 2.0992 8.54878 2.38782 7.25007C2.67897 5.94002 3.176 4.85116 4.01358 4.01358C4.85116 3.176 5.94002 2.67897 7.25007 2.38782Z"
          fill="#0071bd"
        ></path>{" "}
      </g>
    </svg>
  );
};
// ... existing code ...

export const UserAddIcon = () => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height="25px"
      width="25px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <rect width="24" height="24" fill="white"></rect>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 9.5C5 7.01472 7.01472 5 9.5 5C11.9853 5 14 7.01472 14 9.5C14 11.9853 11.9853 14 9.5 14C7.01472 14 5 11.9853 5 9.5Z"
          fill="#0071bd"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.64115 15.6993C5.87351 15.1644 7.49045 15 9.49995 15C11.5112 15 13.1293 15.1647 14.3621 15.7008C15.705 16.2847 16.5212 17.2793 16.949 18.6836C17.1495 19.3418 16.6551 20 15.9738 20H3.02801C2.34589 20 1.85045 19.3408 2.05157 18.6814C2.47994 17.2769 3.29738 16.2826 4.64115 15.6993Z"
          fill="#0071bd"
        ></path>
        <path
          d="M19 3C19 2.44772 18.5523 2 18 2C17.4477 2 17 2.44772 17 3V5H15C14.4477 5 14 5.44772 14 6C14 6.55228 14.4477 7 15 7H17V9C17 9.55228 17.4477 10 18 10C18.5523 10 19 9.55228 19 9V7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H19V3Z"
          fill="#0071bd"
        ></path>
      </g>
    </svg>
  );
};
export const CreditArrow1 = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M12 5l7 7-7 7M5 12h14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DebitArrow1 = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M12 19l-7-7 7-7M5 12h14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const PhonePeIconNew1 = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M11 7h2v7h-2zm0 8h2v2h-2z" />
  </svg>
);
export const NetBanking1 = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 19h19v3H2v-3zm14-9v7h3v-7h-3zm-7-6L2 8v2h19V8l-6-4z" />
  </svg>
);
export const GooglePayIcon1 = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    <path d="M11 14.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5z" />
  </svg>
);
